import React from "react";
import { FaFileAlt } from "react-icons/fa";
import { Boleto } from "../../@types";
import Title from "../title";
import Text from "../text";
import aux from "../../utils/auxiliar";


interface IBoletoCardHomeProps {
  boleto: Boleto;
  isLast: boolean;
  onClick: () => void;
}

function isOverdue(vencBoleto: string): boolean {
  const parts = vencBoleto.split("/");
  if (parts.length !== 3) return false;
  const date = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
}

const BoletoCardHome: React.FC<IBoletoCardHomeProps> = ({ boleto, isLast, onClick }) => {
  const overdue = isOverdue(boleto.vencBoleto);

  return (
    <div
      onClick={onClick}
      className="flex items-center justify-between px-[15px] py-[18px] cursor-pointer transition-all duration-200 hover:bg-[#FAFAFA]"
      style={{ borderBottom: "1px solid #EBE6E7" }}
    >
      <div className="flex items-center gap-[15px]">
        <div className="w-[30px] h-[30px] rounded-[8px] bg-[#D9E6FF] flex items-center justify-center flex-shrink-0">
          <FaFileAlt color="#1566A4" size={15} />
        </div>

        <div className="flex flex-col gap-[3px]">
          <Title className="!text-[0.8125rem] !font-bold">
            {boleto.descEmpresa}
          </Title>
          <Text className="!text-[0.65625rem] !text-[#8D8D8D]">
            Val. Boleto: {aux.maskReal(boleto.valBoleto)}
          </Text>
          <Text className="!text-[0.65625rem] !text-[#8D8D8D]">
            Vencimento: {boleto.vencBoleto}
          </Text>
        </div>
      </div>

      <div className="flex items-center gap-[8px] flex-shrink-0">
        <Text className="!text-[0.65625rem] !text-[#8D8D8D]">
          NF: {boleto.nF}
        </Text>
        <div
          className={`w-[10px] h-[10px] rounded-full ${overdue ? "bg-[#C10303]" : "bg-[#4CAF50]"}`}
        />
      </div>
    </div>
  );
};

export default BoletoCardHome;